import {Button, DirectionalIcon, IconBox, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export interface SupplementaryGuardProps {
  isMainDeclarationSigned: boolean;
  onGoToFatcaCrsStep?: () => void;
  onGoToSellerStep?: () => void;
}

export const SupplementaryGuard: FC<SupplementaryGuardProps> = ({
  isMainDeclarationSigned,
  onGoToFatcaCrsStep,
  onGoToSellerStep
}) => {
  const {t} = useTranslation('trustAccounts');

  const PREFIX = 'activation.packages.compliance.supplementary';
  const reason = !isMainDeclarationSigned ? 'mainDeclarationRequired' : 'sellerDetailsRequired';
  const onCta = !isMainDeclarationSigned ? onGoToFatcaCrsStep : onGoToSellerStep;
  const dataSlot = !isMainDeclarationSigned ? 'main-declaration-guard' : 'developer-guard';

  return (
    <div
      data-slot={dataSlot}
      className="flex flex-wrap items-center gap-4 rounded-xl border border-border bg-background-secondary p-4"
    >
      <IconBox icon="lock" iconColor="brand" className="rounded-full" />
      <div className="flex min-w-48 flex-1 flex-col gap-1 text-start">
        <Typography weight="semibold" className="whitespace-normal">
          {t(`${PREFIX}.${reason}.title`)}
        </Typography>
        <Typography size="sm" color="secondary" className="whitespace-normal">
          {t(`${PREFIX}.${reason}.description`)}
        </Typography>
      </div>
      {onCta && (
        <Button type="button" variant="primary" className="shrink-0" onClick={onCta}>
          {t(`${PREFIX}.${reason}.cta`)}
          <DirectionalIcon name="chevron-forward" className="ms-1 size-4" />
        </Button>
      )}
    </div>
  );
};
